import {all, fork, put, takeEvery,takeLatest, call, delay} from "redux-saga/effects"

import {
  DEPARTMENT_PREVIEW,
  DEPARTMENT_NEW,
  DEPARTMENT_UPDATE,
  DEPARTMENT_REMOVE,
  DEPARTMENT_SEARCH
} from "constants/ActionTypes"

import {departmentDataSourceUpdate,departmentProcessSuccess,departmentProcessReset} from "appRedux/actions/setup/department/Department"
import {userSignOut} from "appRedux/actions/Auth"

import { APIGetRequest,APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isUndefined,filter,orderBy } from "lodash"
import { IndexedDBAdd,IndexDBGetDataAll } from "util/indexedDBLibrary"
import { getItems } from "util/localStorage"
import { ApiResponse } from "constants/ActionTypes"

function* departmentPreviewProcess(): Generator<any, void, any>{
    
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/rpc/masterfile/department/list`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

    try {
      const response: ApiResponse = yield APIPostRequest(url, {}, API_PMS_HEADERS)

      if(response.status === 200)
      {
            const resultData = response.data?.result_data || response.data || []
            const departmentDataSource = resultData.map((obj: any, key: number) =>{
              const container = {} as any
                    container.key = key
                    container.department_id = obj.id
                    container.department_code = obj.code
                    container.department_name = obj.name
                    container.department_group_id = obj.group_id
                    container.department_group_name = obj.group
                    container.dept_type = obj.dept_type
                    container.require_info = obj.require_info
                    container.itemizers = obj.itemizers
                    container.enabled = obj.enabled
                    container.vat_effect = obj.vat_effect

                return container
            })

            /* if no error put everything to reducer */
             yield put(departmentDataSourceUpdate(departmentDataSource))
             yield delay(100)
             yield IndexedDBAdd("ListBoxDB","objStoreDepartmentList",departmentDataSource)

      }else{
            /* Show error message and signout */
            const {message,data} = response.data || {}
            const processStatus = { status: false, action: "preview", message}
            yield put(departmentProcessSuccess(processStatus))
            yield delay(100)
            yield put(departmentProcessReset())
            yield delay(100)
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
            
      }
      
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error}
        yield put(departmentProcessSuccess(processStatus))
        yield delay(100)
        yield put(departmentProcessReset())
        yield delay(100)
    }
    
}

function* departmentSearchProcess({payload}: any): Generator<any, void, any>{
  const storeValue = yield IndexDBGetDataAll('ListBoxDB', 'objStoreDepartmentList')
  const ReformalData = [...storeValue[0]]
  const keyword = payload.toLowerCase()

  if(!isUndefined(keyword)){
      /* Search by name */
      const filtered_department_name = filter(ReformalData, function(o) {
        return o.department_name.toLowerCase().indexOf(keyword) > -1
      })

      const mergeData = [...new Set([...filtered_department_name])]

      yield put(departmentDataSourceUpdate(mergeData))
  }else 
      yield put(departmentDataSourceUpdate(ReformalData))
}

function* departmentCreateProcess({payload}: any): Generator<any, void, any>{

  const department_name = payload.department_name
  const department_code = payload.department_code
  const groupID = payload.department_group_id||null
  const deptType = payload.dept_type
  const requireInfo = payload.require_info||false
  const itemizers = payload.itemizers
  const active = payload.active
  const vatEffect = payload.vat_effect !== undefined ? payload.vat_effect : true

  let departmentInfo = {name:department_name,
                        code:department_code,
                        group_id:groupID,
                        dept_type:deptType,
                        require_info:requireInfo,
                        itemizers,
                        enabled:active,
                        vat_effect:vatEffect}
      
      
      try {
            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/rpc/masterfile/department/create`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = departmentInfo
            const response: ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
                const resultCode = response.data?.result_code
                const resultMsg = response.data?.result_msg || response.data?.message
                
                if(resultCode === "0" || resultCode === 0){
                    const processStatus = { status: true, action: "create", message:"Create success."}
                    yield put(departmentProcessSuccess(processStatus))
                    yield delay(100)
                    yield put(departmentProcessReset())
                    yield delay(100)
                } else {
                    const processStatus = { status: false, action: "create", message: resultMsg || "Create failed."}
                    yield put(departmentProcessSuccess(processStatus))
                    yield delay(100)
                    yield put(departmentProcessReset())
                    yield delay(100)
                }
            }else{
              const {message,data} = response.data || {}
              const processStatus = { status: false, action: "create", message: message || "Create failed."}
              yield put(departmentProcessSuccess(processStatus))
              yield delay(100)
              yield put(departmentProcessReset())
              yield delay(100)
              if(response.status === 403){
                /* if data is not null force signout */
                if(data)
                  yield put(userSignOut())
              }
            }

      } catch (error) {
            const processStatus = { status: false, action: "create", message:error}
            yield put(departmentProcessSuccess(processStatus))
            yield delay(100)
            yield put(departmentProcessReset())
            yield delay(100)
      }
}

function* departmentUpdateProcess({payload}: any): Generator<any, void, any>{
  const department_name = payload.department_name
  const department_id = payload.department_id
  const department_code = payload.department_code
  const groupID = payload.department_group_id||null
  const deptType = payload.dept_type
  const requireInfo = payload.require_info
  const itemizers = payload.itemizers
  const active = payload.active
  const vatEffect = payload.vat_effect !== undefined ? payload.vat_effect : true

  let departmentInfo = {} as any
      departmentInfo.id = department_id
      departmentInfo.name = department_name
      departmentInfo.code = department_code
      departmentInfo.group_id = groupID
      departmentInfo.dept_type = deptType
      departmentInfo.require_info = requireInfo
      departmentInfo.itemizers = itemizers
      departmentInfo.enabled = active
      departmentInfo.vat_effect = vatEffect
  
  try {
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/rpc/masterfile/department/update`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY  = departmentInfo
        const response: ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

        if(response.status === 200){
            const resultCode = response.data?.result_code
            const resultMsg = response.data?.result_msg || response.data?.message
            
            if(resultCode === "0" || resultCode === 0){
                const processStatus = { status: true, action: "update", message:"Update success."}
                yield put(departmentProcessSuccess(processStatus))
                yield delay(100)
                yield put(departmentProcessReset())
                yield delay(100)
            } else {
                const processStatus = { status: false, action: "update", message: resultMsg || "Update failed."}
                yield put(departmentProcessSuccess(processStatus))
                yield delay(100)
                yield put(departmentProcessReset())
                yield delay(100)
            }
        }else {
          const {message,data} = response.data || {}
          const processStatus = { status: false, action: "update", message: message || "Update failed."}
          yield put(departmentProcessSuccess(processStatus))
          yield delay(100)
          yield put(departmentProcessReset())
          yield delay(100)
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }

  } catch (error) {
        const processStatus = { status: false, action: "update", message:error}
        yield put(departmentProcessSuccess(processStatus))
        yield delay(100)
        yield put(departmentProcessReset())
        yield delay(100)
  }
}

function* departmentRemoveProcess({payload}: any): Generator<any, void, any>{
    const departmentRemove = payload
    
    try{
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/department/delete/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY = {id : departmentRemove}
        const response: ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)
        if(response.status === 200){
          const processStatus = { status: true, action: "delete", message:"Delete success."}
          yield put(departmentProcessSuccess(processStatus))
          yield delay(100)
          yield put(departmentProcessReset())
          yield delay(100)
        }else{
          const {message,data} = response.data || {}
          const processStatus = { status: false, action: "delete", message}
          yield put(departmentProcessSuccess(processStatus))
          yield delay(100)
          yield put(departmentProcessReset())
          yield delay(100)
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }  
    }
    catch(error){
      const processStatus = { status: false, action: "delete", message:error}
      yield put(departmentProcessSuccess(processStatus))
      yield delay(100)
      yield put(departmentProcessReset())
      yield delay(100)
    }
}

/* Watcher Saga */
export function* departmentPreview() {
  yield takeLatest(DEPARTMENT_PREVIEW, departmentPreviewProcess)
}
export function* departmentSearch(){
  yield takeLatest(DEPARTMENT_SEARCH, departmentSearchProcess)
}
export function* departmentCreate(){
  yield takeEvery(DEPARTMENT_NEW,departmentCreateProcess)
}
export function* departmentUpdate(){
  yield takeEvery(DEPARTMENT_UPDATE, departmentUpdateProcess)
}
export function* departmentRemove(){
  yield takeEvery(DEPARTMENT_REMOVE,departmentRemoveProcess)
}

export default function* rootSaga(): Generator<any, void, any> {
  yield all([fork(departmentPreview),
             fork(departmentSearch),
             fork(departmentCreate),
             fork(departmentUpdate),
             fork(departmentRemove)])


}